/**
 * Redux Store Configuration
 *
 * Configures the Redux store with saga middleware for async side effects
 * and redux-persist for persisting login state across page reloads.
 *
 * SECURITY FIX: redux-logger is now conditionally loaded only in development.
 * In production, only sagaMiddleware is active to prevent sensitive data leakage.
 */
import { legacy_createStore as createStore, applyMiddleware } from 'redux';
import { persistStore } from 'redux-persist';
import logger from 'redux-logger';
import createSagaMiddleware from 'redux-saga';

import rootReducer from './root-reducer';
import rootSaga from './root-saga';

// Create saga middleware for handling async API calls
const sagaMiddleware = createSagaMiddleware();

// SECURITY FIX: Logger only included in development to prevent leaking Redux state in production
const middlewares: any =
	process.env.NODE_ENV === 'development' ? [sagaMiddleware, logger] : [sagaMiddleware];

// Create store with persisted reducer and middleware chain
export const store = createStore(rootReducer, applyMiddleware(...middlewares));

// Start all saga watchers
sagaMiddleware.run(rootSaga);

// Create persistor for redux-persist (persists login state to localStorage)
export const persistor = persistStore(store);

export default { store, persistStore };
